import { Component } from 'react';
import PropTypes from 'prop-types';

import { ALBUM_SUBTYPE, ALBUM_TYPE } from '../../constants/albums';
import { getContextualString } from '../../util/context-strings';
import { BASENAME } from '../../constants/basenames';
import contextualStrings from '../../strings/strings';

class ContextualString extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(ALBUM_TYPE)),
    subtype: PropTypes.oneOf(Object.values(ALBUM_SUBTYPE)),
    basename: PropTypes.oneOf(Object.values(BASENAME)),
    defaultMessage: PropTypes.string,
    formatter: PropTypes.func,
    values: PropTypes.object,
    strings: PropTypes.object,
  };

  static defaultProps = {
    formatter: x => x,
    strings: contextualStrings,
  };

  render() {
    const {
      id,
      type,
      subtype,
      basename,
      defaultMessage,
      formatter,
      values,
      strings,
      eventType,
    } = this.props;

    return formatter(
      getContextualString({
        id,
        type,
        subtype,
        basename,
        defaultMessage,
        values,
        strings,
        eventType,
      }),
    );
  }
}

export default ContextualString;
